import { all } from 'redux-saga/effects';
import delTenant from './delete';
import getTenant from './get';
import postTenant from './post';
import patchTenant from './patch';

export default all([delTenant, getTenant, postTenant, patchTenant]);
